import React from 'react';
import { FaCheckCircle, FaExclamationCircle, FaQuestionCircle } from 'react-icons/fa';

export interface RowAvailabilityIconProps {
	hasPriceAgreement: boolean;
	status: string;
}

export function RowAvailabilityIcon({ hasPriceAgreement, status }: RowAvailabilityIconProps) {
	if (!hasPriceAgreement) {
		return <FaExclamationCircle className='w-4 h-4 text-red-600' />;
	}
	if (status === 'unavailable') {
		return <FaQuestionCircle className='w-4 h-4 text-yellow-600' />;
	}
	return <FaCheckCircle className='w-4 h-4 text-green-600' />;
}
